(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[12],{

/***/ "9cz1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchAllFavoriteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addListingToFavoriteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createFavoriteList; });
/* unused harmony export fetchAllFavoriteListItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteFavoriteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchFavoriteByIdIndexed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeListingFromFavoriteList; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HaE+");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("gt1D");
/* harmony import */ var _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("g33+");






var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_2___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var fetchAllFavoriteList = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2() {
    var token;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!_src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isTokenExpired()) {
              _context2.next = 3;
              break;
            }

            _context2.next = 3;
            return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

          case 3:
            token = _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getAuthToken();
            return _context2.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.ref, "/e6t/v2/favorites/"), {
              headers: {
                Authorization: "".concat(token)
              }
            }).then(function (response) {
              return response.data;
            })["catch"]( /*#__PURE__*/function () {
              var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(error) {
                var _error$response, _error$response$data;

                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!(((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.status) === 401)) {
                          _context.next = 3;
                          break;
                        }

                        _context.next = 3;
                        return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

                      case 3:
                        return _context.abrupt("return", error);

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllFavoriteList() {
    return _ref.apply(this, arguments);
  };
}();
var addListingToFavoriteList = /*#__PURE__*/function () {
  var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee4(id, listingId) {
    var token;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!_src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isTokenExpired()) {
              _context4.next = 3;
              break;
            }

            _context4.next = 3;
            return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

          case 3:
            token = _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getAuthToken();
            return _context4.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].post("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.ref, "/e6t/v2/favorites/").concat(id, "/addListing/").concat(listingId, "/"), null, {
              headers: {
                Authorization: "".concat(token)
              }
            }).then(function (response) {
              return response.data;
            })["catch"]( /*#__PURE__*/function () {
              var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(error) {
                var _error$response2, _error$response2$data;

                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.status) === 401)) {
                          _context3.next = 3;
                          break;
                        }

                        _context3.next = 3;
                        return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

                      case 3:
                        return _context3.abrupt("return", error);

                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x4) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function addListingToFavoriteList(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
var createFavoriteList = /*#__PURE__*/function () {
  var _ref5 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee6(title) {
    var token;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!_src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isTokenExpired()) {
              _context6.next = 3;
              break;
            }

            _context6.next = 3;
            return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

          case 3:
            token = _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getAuthToken();
            return _context6.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].post("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.ref, "/e6t/v2/favorites/"), {
              title: title
            }, {
              headers: {
                Authorization: "".concat(token)
              }
            }).then(function (response) {
              return response.data;
            })["catch"]( /*#__PURE__*/function () {
              var _ref6 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee5(error) {
                var _error$response3, _error$response3$data;

                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!(((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.status) === 401)) {
                          _context5.next = 3;
                          break;
                        }

                        _context5.next = 3;
                        return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

                      case 3:
                        return _context5.abrupt("return", error.response);

                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x6) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function createFavoriteList(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
var fetchAllFavoriteListItem = /*#__PURE__*/function () {
  var _ref7 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee8(id) {
    var token;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!_src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isTokenExpired()) {
              _context8.next = 3;
              break;
            }

            _context8.next = 3;
            return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

          case 3:
            token = _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getAuthToken();
            return _context8.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.ref, "/e6t/v2/favorites/").concat(id, "/detail/"), {
              headers: {
                Authorization: "".concat(token)
              }
            }).then(function (response) {
              return response.data;
            })["catch"]( /*#__PURE__*/function () {
              var _ref8 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee7(error) {
                var _error$response4, _error$response4$data;

                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!(((_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.status) === 401)) {
                          _context7.next = 3;
                          break;
                        }

                        _context7.next = 3;
                        return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

                      case 3:
                        return _context7.abrupt("return", error);

                      case 4:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x8) {
                return _ref8.apply(this, arguments);
              };
            }()));

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function fetchAllFavoriteListItem(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
var deleteFavoriteList = /*#__PURE__*/function () {
  var _ref9 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee10(id) {
    var token;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!_src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isTokenExpired()) {
              _context10.next = 3;
              break;
            }

            _context10.next = 3;
            return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

          case 3:
            token = _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getAuthToken();
            _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]["delete"]("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.ref, "/e6t/v2/favorites/").concat(id, "/"), {
              headers: {
                Authorization: "".concat(token)
              }
            }).then(function (response) {
              return response.data;
            })["catch"]( /*#__PURE__*/function () {
              var _ref10 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee9(error) {
                var _error$response5, _error$response5$data;

                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        if (!(((_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : (_error$response5$data = _error$response5.data) === null || _error$response5$data === void 0 ? void 0 : _error$response5$data.status) === 401)) {
                          _context9.next = 3;
                          break;
                        }

                        _context9.next = 3;
                        return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

                      case 3:
                        return _context9.abrupt("return", error);

                      case 4:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));

              return function (_x10) {
                return _ref10.apply(this, arguments);
              };
            }());

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function deleteFavoriteList(_x9) {
    return _ref9.apply(this, arguments);
  };
}();
var fetchFavoriteByIdIndexed = /*#__PURE__*/function () {
  var _ref11 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee12(id) {
    var token;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (!_src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isTokenExpired()) {
              _context12.next = 3;
              break;
            }

            _context12.next = 3;
            return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

          case 3:
            token = _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getAuthToken();
            return _context12.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.ref, "/e6t/v2/favorites/").concat(id, "/detail"), {
              headers: {
                Authorization: "".concat(token)
              }
            }).then(function (response) {
              return response.data;
            })["catch"]( /*#__PURE__*/function () {
              var _ref12 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee11(error) {
                var _error$response6, _error$response6$data;

                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        if (!(((_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$data = _error$response6.data) === null || _error$response6$data === void 0 ? void 0 : _error$response6$data.status) === 401)) {
                          _context11.next = 3;
                          break;
                        }

                        _context11.next = 3;
                        return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

                      case 3:
                        return _context11.abrupt("return", error);

                      case 4:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11);
              }));

              return function (_x12) {
                return _ref12.apply(this, arguments);
              };
            }()));

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function fetchFavoriteByIdIndexed(_x11) {
    return _ref11.apply(this, arguments);
  };
}();
var removeListingFromFavoriteList = /*#__PURE__*/function () {
  var _ref13 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee14(id) {
    var token;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!_src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isTokenExpired()) {
              _context14.next = 3;
              break;
            }

            _context14.next = 3;
            return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

          case 3:
            token = _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getAuthToken();
            _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]["delete"]("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.ref, "/e6t/v2/favorites/removeListing/").concat(id, "/"), {
              headers: {
                Authorization: "".concat(token)
              }
            }).then(function (response) {
              return response.data;
            })["catch"]( /*#__PURE__*/function () {
              var _ref14 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee13(error) {
                var _error$response7, _error$response7$data;

                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee13$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        if (!(((_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : (_error$response7$data = _error$response7.data) === null || _error$response7$data === void 0 ? void 0 : _error$response7$data.status) === 401)) {
                          _context13.next = 3;
                          break;
                        }

                        _context13.next = 3;
                        return _src_helpers_auth__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].getNewToken();

                      case 3:
                        return _context13.abrupt("return", error);

                      case 4:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee13);
              }));

              return function (_x14) {
                return _ref14.apply(this, arguments);
              };
            }());

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function removeListingFromFavoriteList(_x13) {
    return _ref13.apply(this, arguments);
  };
}();

/***/ }),

/***/ "FWZ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/redux-store/actions/auth/index.js
var auth = __webpack_require__("2oy/");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./services/favorites-e6t.js
var favorites_e6t = __webpack_require__("9cz1");

// EXTERNAL MODULE: ./src/redux-store/action-types/favorites/index.js
var favorites = __webpack_require__("Wwwu");

// EXTERNAL MODULE: ./src/helpers/notifier/index.js
var notifier = __webpack_require__("Z0GP");

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__("mOvS");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./src/redux-store/actions/favorites/index.js





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var logger = true;

var log = function log(message) {
  if (logger) {
    console.log(message);
  }
};

var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var favorites_fetchAllFavoriteList = function fetchAllFavoriteList() {
  return function (dispatch, getState) {
    return new Promise( /*#__PURE__*/function () {
      var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(resolve, reject) {
        var _response$result, _ref2, authToken, response, favoriteList, favoriteItemListAll, favoriteListings;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: favorites["q" /* FETCH_FAVORITE_LIST_FROM_SERVICE_LOADING */],
                  payload: {
                    loading: true,
                    favoriteList: [],
                    allFavoriteListings: [],
                    error: null,
                    currentPopperContent: 'loading'
                  }
                });
                _context.prev = 1;
                authToken = getState().auth.data.Authorization;
                /* const isAuth = getState().auth.isAuth;
                if (!isAuth) {
                  const e = new Error('Authentication not found');
                  throw e;
                } */

                _context.next = 5;
                return favorites_e6t["d" /* fetchAllFavoriteList */](authToken);

              case 5:
                response = _context.sent;
                favoriteList = (response === null || response === void 0 ? void 0 : (_response$result = response.result) === null || _response$result === void 0 ? void 0 : _response$result.favoriteListV2ResponseList) || [];
                favoriteItemListAll = [];
                favoriteList.forEach(function (list) {
                  list.idList.forEach(function (item) {
                    favoriteItemListAll.push(item);
                  });
                });
                _context.next = 11;
                return (_ref2 = []).concat.apply(_ref2, favoriteItemListAll);

              case 11:
                favoriteListings = _context.sent;
                dispatch({
                  type: favorites["r" /* FETCH_FAVORITE_LIST_FROM_SERVICE_SUCCESS */],
                  payload: {
                    loading: false,
                    favoriteList: favoriteList,
                    favoriteListings: favoriteListings,
                    error: null,
                    currentPopperContent: (favoriteList === null || favoriteList === void 0 ? void 0 : favoriteList.length) > 0 ? 'list' : 'empty'
                  }
                });
                resolve(true);
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: favorites["p" /* FETCH_FAVORITE_LIST_FROM_SERVICE_ERROR */],
                  payload: {
                    loading: false,
                    favoriteList: [],
                    favoriteListings: [],
                    error: _context.t0,
                    currentPopperContent: 'error'
                  }
                });
                reject(_context.t0);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 16]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};
var favorites_createFavoriteList = function createFavoriteList(listname) {
  return function (dispatch, getState) {
    return new Promise( /*#__PURE__*/function () {
      var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(resolve, reject) {
        var authToken, favoriteList, _response$result2, _response$result3, _ref4, response, error, newFavoriteList, favoriteItemListAll, favoriteListings;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: favorites["h" /* CREATE_FAVORITE_LIST_LOADING */],
                  payload: {
                    loading: true,
                    error: null,
                    currentPopperContent: 'loading'
                  }
                });
                authToken = getState().auth.data.Authorization;
                favoriteList = getState().favorites.favoriteList;
                _context2.prev = 3;
                _context2.next = 6;
                return favorites_e6t["b" /* createFavoriteList */](listname, authToken);

              case 6:
                response = _context2.sent;
                error = (response === null || response === void 0 ? void 0 : response.status) === 400;

                if (!error) {
                  _context2.next = 10;
                  break;
                }

                throw new Error(error);

              case 10:
                newFavoriteList = [].concat(Object(toConsumableArray["a" /* default */])(favoriteList), [{
                  "id": response === null || response === void 0 ? void 0 : (_response$result2 = response.result) === null || _response$result2 === void 0 ? void 0 : _response$result2.id,
                  "title": response === null || response === void 0 ? void 0 : (_response$result3 = response.result) === null || _response$result3 === void 0 ? void 0 : _response$result3.title,
                  "count": 0,
                  "coverPhotoUrl": null,
                  "idList": []
                }]);
                favoriteItemListAll = [];
                newFavoriteList.forEach(function (list) {
                  list.idList.forEach(function (item) {
                    favoriteItemListAll.push(item);
                  });
                });
                _context2.next = 15;
                return (_ref4 = []).concat.apply(_ref4, favoriteItemListAll);

              case 15:
                favoriteListings = _context2.sent;
                dispatch({
                  type: favorites["i" /* CREATE_FAVORITE_LIST_SUCCESS */],
                  payload: {
                    loading: false,
                    favoriteList: newFavoriteList,
                    favoriteListings: favoriteListings,
                    error: null,
                    newFavoriteList: favoriteList,
                    currentPopperContent: 'list'
                  }
                });
                resolve(true);
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](3);
                dispatch({
                  type: favorites["g" /* CREATE_FAVORITE_LIST_ERROR */],
                  payload: {
                    loading: false,
                    error: _context2.t0,
                    currentPopperContent: 'new-list'
                  }
                });
                reject(_context2.t0);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 20]]);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());
  };
};
var favorites_addListingToFavoriteList = function addListingToFavoriteList(listId, listingId) {
  return function (dispatch, getState) {
    return new Promise( /*#__PURE__*/function () {
      var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3(resolve, reject) {
        var authToken, favoriteList, _ref6, _response$data, _response$data$result, response, newFavoriteList, favoriteItemListAll, favoriteListName, listName, favoriteListings;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch({
                  type: favorites["b" /* ADD_LISTING_TO_FAVORITE_LIST_LOADING */],
                  payload: {
                    loading: true,
                    error: null,
                    currentPopperContent: 'loading'
                  }
                });
                authToken = getState().auth.data.Authorization;
                favoriteList = getState().favorites.favoriteList;
                _context3.prev = 3;
                _context3.next = 6;
                return favorites_e6t["a" /* addListingToFavoriteList */](listId, listingId, authToken);

              case 6:
                response = _context3.sent;

                if (!((response === null || response === void 0 ? void 0 : response.status) === 'error')) {
                  _context3.next = 9;
                  break;
                }

                throw new Error(response.data.description.tr);

              case 9:
                newFavoriteList = favoriteList.map(function (listItem) {
                  if (listItem.id == listId) {
                    return _objectSpread(_objectSpread({}, listItem), {}, {
                      count: listItem.count + 1,
                      idList: [].concat(Object(toConsumableArray["a" /* default */])(listItem.idList), [listingId])
                    });
                  }

                  return listItem;
                });
                favoriteItemListAll = [];
                favoriteListName = newFavoriteList === null || newFavoriteList === void 0 ? void 0 : newFavoriteList.filter(function (item) {
                  return item.id === listId;
                });
                listName = (favoriteListName === null || favoriteListName === void 0 ? void 0 : favoriteListName.length) > 0 ? favoriteListName[0].title : '';
                newFavoriteList.forEach(function (list) {
                  list.idList.forEach(function (item) {
                    favoriteItemListAll.push(item);
                  });
                });
                _context3.next = 16;
                return (_ref6 = []).concat.apply(_ref6, favoriteItemListAll);

              case 16:
                favoriteListings = _context3.sent;
                dispatch({
                  type: favorites["c" /* ADD_LISTING_TO_FAVORITE_LIST_SUCCESS */],
                  payload: {
                    loading: false,
                    favoriteList: newFavoriteList,
                    favoriteListings: favoriteListings,
                    error: null,
                    newFavoriteListItem: response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$result = _response$data.result) === null || _response$data$result === void 0 ? void 0 : _response$data$result.favoriteId,
                    currentPopperContent: 'list'
                  }
                });
                Object(notifier["a" /* default */])("<img src=\"/static/icons/success-modal.png\" alt=\"/static/icons/success-modal.png\" />\n        \u0130lan <b>".concat(listName, "</b> favori listenize eklendi. <a href=\"").concat(publicRuntimeConfig.apps.panel.hostname, "/#/member/authorize?token=").concat(authToken, "&redirectUrl=favori-listelerim\" target=\"blank\">Listeye Git</a>"), 'favorite', '5000', 'favorite');
                resolve(true);
                _context3.next = 27;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](3);
                dispatch({
                  type: favorites["a" /* ADD_LISTING_TO_FAVORITE_LIST_ERROR */],
                  payload: {
                    loading: false,
                    error: _context3.t0,
                    currentPopperContent: 'list'
                  }
                });
                Object(notifier["a" /* default */])('Ekleme işlemi yapılırken bir hata meydana geldi.', 'error');
                reject(_context3.t0);

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 22]]);
      }));

      return function (_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }());
  };
};
var favorites_removeListingFromFavoriteList = function removeListingFromFavoriteList(listId) {
  return function (dispatch, getState) {
    return new Promise( /*#__PURE__*/function () {
      var _ref7 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee4(resolve, reject) {
        var authToken, favoriteList, _ref8, response, newFavoriteList, favoriteItemListAll, favoriteListings, foundItem, _ref9, id, title, favoriteRemoveItemTitle, favoriteRemoveItemId;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: favorites["v" /* REMOVE_LISTING_FROM_FAVORITE_LOADING */],
                  payload: {
                    loading: true,
                    error: null,
                    currentPopperContent: 'loading'
                  }
                });
                authToken = getState().auth.data.Authorization;
                favoriteList = getState().favorites.favoriteList;
                _context4.prev = 3;
                _context4.next = 6;
                return favorites_e6t["f" /* removeListingFromFavoriteList */](listId, authToken);

              case 6:
                response = _context4.sent;
                newFavoriteList = favoriteList.map(function (listItem) {
                  var newIdList = listItem.idList.filter(function (l) {
                    return l !== listId;
                  });
                  return _objectSpread(_objectSpread({}, listItem), {}, {
                    count: listItem.count - 1,
                    idList: newIdList
                  });
                });

                if (!((response === null || response === void 0 ? void 0 : response.status) === 'error')) {
                  _context4.next = 10;
                  break;
                }

                throw new Error(response.data.description.tr);

              case 10:
                favoriteItemListAll = [];
                newFavoriteList.forEach(function (list) {
                  list.idList.forEach(function (item) {
                    favoriteItemListAll.push(item);
                  });
                });
                _context4.next = 14;
                return (_ref8 = []).concat.apply(_ref8, favoriteItemListAll);

              case 14:
                favoriteListings = _context4.sent;
                dispatch({
                  type: favorites["w" /* REMOVE_LISTING_FROM_FAVORITE_SUCCESS */],
                  payload: {
                    loading: false,
                    favoriteList: newFavoriteList,
                    favoriteListings: favoriteListings,
                    error: null,
                    currentPopperContent: 'list'
                  }
                });
                foundItem = favoriteList.find(function (item) {
                  return item.idList.includes(listId);
                });
                _ref9 = foundItem || {}, id = _ref9.id, title = _ref9.title;
                favoriteRemoveItemTitle = foundItem ? title : null;
                favoriteRemoveItemId = foundItem ? id : null;

                if (favoriteRemoveItemTitle && favoriteRemoveItemId) {
                  Object(notifier["a" /* default */])("<img src=\"/static/icons/success-modal.png\" alt=\"/static/icons/success-modal.png\" />\n          \u0130lan <b>".concat(favoriteRemoveItemTitle, "</b> favori listenizden \xE7\u0131kar\u0131ld\u0131. <a href=\"").concat(publicRuntimeConfig.apps.panel.hostname, "/#/member/authorize?token=").concat(authToken, "&redirectUrl=favori-listelerim\" target=\"blank\">Listeye Git</a>"), 'favorite', '5000', 'favorite');
                }

                resolve(true);
                _context4.next = 29;
                break;

              case 24:
                _context4.prev = 24;
                _context4.t0 = _context4["catch"](3);
                dispatch({
                  type: favorites["u" /* REMOVE_LISTING_FROM_FAVORITE_ERROR */],
                  payload: {
                    loading: false,
                    error: _context4.t0,
                    currentPopperContent: 'list'
                  }
                });
                Object(notifier["a" /* default */])('Çıkartma işlemi yapılırken bir hata meydana geldi.', 'error');
                reject(_context4.t0);

              case 29:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 24]]);
      }));

      return function (_x7, _x8) {
        return _ref7.apply(this, arguments);
      };
    }());
  };
};
var favorites_changeCurrentPopperContent = function changeCurrentPopperContent(currentPopperContentName) {
  return function (dispatch) {
    dispatch({
      type: favorites["f" /* CHANGE_POPPER_CONTENT */],
      payload: {
        currentPopperContent: currentPopperContentName,
        newFavoriteList: null,
        error: null
      }
    });
  };
};
var favorites_newFavoriteListMessageToogle = function newFavoriteListMessageToogle() {
  return function (dispatch) {
    dispatch({
      type: favorites["e" /* ADD_NEW_FAVORITE_LIST_MESSAGE_TOOGLE */],
      payload: {
        newFavoriteList: null
      }
    });
  };
};
var favorites_newFavoriteListItemMessageToogle = function newFavoriteListItemMessageToogle() {
  return function (dispatch) {
    dispatch({
      type: favorites["d" /* ADD_NEW_FAVORITE_LIST_ITEM_MESSAGE_TOOGLE */],
      payload: {
        newFavoriteListItem: null
      }
    });
  };
};
var favorites_deleteFavoriteList = function deleteFavoriteList(favoriteListId) {
  return function (dispatch, getState) {
    return new Promise( /*#__PURE__*/function () {
      var _ref10 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee5(resolve, reject) {
        var authToken, _responseFetch$result, _ref11, response, error, responseFetch, favoriteList, favoriteItemListAll, favoriteListings;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dispatch({
                  type: favorites["k" /* DELETE_FAVORITE_LIST_LOADING */],
                  payload: {
                    loading: true
                  }
                });
                authToken = getState().auth.data.Authorization;
                _context5.prev = 2;
                _context5.next = 5;
                return favorites_e6t["c" /* deleteFavoriteList */](favoriteListId, authToken);

              case 5:
                response = _context5.sent;
                error = lodash_default.a.get(response, 'response.data.error', null);

                if (!error) {
                  _context5.next = 9;
                  break;
                }

                throw new Error(error);

              case 9:
                _context5.next = 11;
                return favorites_e6t["d" /* fetchAllFavoriteList */](authToken);

              case 11:
                responseFetch = _context5.sent;
                favoriteList = (responseFetch === null || responseFetch === void 0 ? void 0 : (_responseFetch$result = responseFetch.result) === null || _responseFetch$result === void 0 ? void 0 : _responseFetch$result.favoriteListV2ResponseList) || [];
                favoriteItemListAll = [];
                favoriteList.forEach(function (list) {
                  list.idList.forEach(function (item) {
                    favoriteItemListAll.push(item);
                  });
                });
                _context5.next = 17;
                return (_ref11 = []).concat.apply(_ref11, favoriteItemListAll);

              case 17:
                favoriteListings = _context5.sent;
                dispatch({
                  type: favorites["l" /* DELETE_FAVORITE_LIST_SUCCESS */],
                  payload: {
                    loading: false,
                    favoriteList: favoriteList,
                    favoriteListings: favoriteListings,
                    error: null
                  }
                });
                resolve(true);
                _context5.next = 26;
                break;

              case 22:
                _context5.prev = 22;
                _context5.t0 = _context5["catch"](2);
                dispatch({
                  type: favorites["j" /* DELETE_FAVORITE_LIST_ERROR */],
                  payload: {
                    loading: false,
                    error: _context5.t0
                  }
                });
                reject(_context5.t0);

              case 26:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 22]]);
      }));

      return function (_x9, _x10) {
        return _ref10.apply(this, arguments);
      };
    }());
  };
};
var favorites_fetchListingDetailById = function fetchListingDetailById(favoriteListId) {
  return function (dispatch, getState) {
    return new Promise( /*#__PURE__*/function () {
      var _ref12 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee6(resolve, reject) {
        var authToken, response, data;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dispatch({
                  type: favorites["n" /* FETCH_FAVORITE_LIST_DETAIL_LOADING */],
                  payload: {
                    loading: true,
                    error: null
                  }
                });
                authToken = getState().auth.data.Authorization;
                _context6.prev = 2;
                _context6.next = 5;
                return favorites_e6t["e" /* fetchFavoriteByIdIndexed */](favoriteListId, authToken);

              case 5:
                response = _context6.sent;
                data = (response === null || response === void 0 ? void 0 : response.result) || [];
                dispatch({
                  type: favorites["o" /* FETCH_FAVORITE_LIST_DETAIL_SUCCESS */],
                  payload: {
                    favoriteListings: data,
                    loading: false,
                    error: false
                  }
                });
                _context6.next = 14;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](2);
                dispatch({
                  type: favorites["m" /* FETCH_FAVORITE_LIST_DETAIL_ERROR */],
                  payload: {
                    loading: false,
                    error: _context6.t0
                  }
                });
                reject(_context6.t0);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 10]]);
      }));

      return function (_x11, _x12) {
        return _ref12.apply(this, arguments);
      };
    }());
  };
};
// CONCATENATED MODULE: ./src/redux-store/containers/favorites/index.js
/* eslint-disable no-underscore-dangle */


var mapDispatchToProps = {
  authenticationModalToogle: auth["b" /* authenticationModalToogle */],
  authenticationModalClose: auth["a" /* authenticationModalClose */],
  fetchAllFavoriteList: favorites_fetchAllFavoriteList,
  createFavoriteList: favorites_createFavoriteList,
  addListingToFavoriteList: favorites_addListingToFavoriteList,
  removeListingFromFavoriteList: favorites_removeListingFromFavoriteList,
  changeCurrentPopperContent: favorites_changeCurrentPopperContent,
  newFavoriteListMessageToogle: favorites_newFavoriteListMessageToogle,
  newFavoriteListItemMessageToogle: favorites_newFavoriteListItemMessageToogle,
  deleteFavoriteList: favorites_deleteFavoriteList,
  fetchListingDetailById: favorites_fetchListingDetailById
};
/**
 * Map selected state objects to the connected component's props.
 */

var mapStateToProps = function mapStateToProps(state) {
  return {
    authenticationModalState: state.auth.authenticationModalState,
    authenticationModalActiveComponent: state.auth.authenticationModalActiveComponent,
    authenticationModalTitle: state.auth.authenticationModalTitle,
    isAuth: state.auth.isAuth,
    loading: state.favorites.loading,
    favoriteList: state.favorites.favoriteList,
    allFavoriteListings: state.favorites.favoriteListings,
    error: state.favorites.error,
    currentPopperContent: state.favorites.currentPopperContent,
    newFavoriteList: state.favorites.newFavoriteList,
    newFavoriteListItem: state.favorites.newFavoriteListItem,
    favoriteListings: state.favorites.favoriteListings
  };
};

/* harmony default export */ var containers_favorites = __webpack_exports__["a"] = ([mapStateToProps, mapDispatchToProps]);

/***/ })

}]);